<template>
  <div>
    <router-view/>
    <fullScreenLoadingView></fullScreenLoadingView>
    <actionResult ref="actionResultView"></actionResult>
  </div>
</template>
<script>
import fullScreenLoadingView from '@/components/fullScreenLoadingView.vue'
import actionResult from '@/components/actionResult.vue'
export default {
  name: 'App',
  data(){
    return {
      
    }
  },
  watch: {
    $route(to, from) {
      // 這裡可以監聽到路由的變化
      // this.$debug('Route changed to', to);
      // this.$debug('Route changed from', from, 'to', to);
      // 在這裡執行你想要的操作
      if (
        to.matched[1] &&
        to.matched[1].name
      ) {
        this.$store.state.nowPage = to.matched[1].name
      }
    }
  },
  components: { fullScreenLoadingView , actionResult },
  methods:{
    isLineBrowser() {
      return /Line/i.test(navigator.userAgent);
    },
    autoOpenExternalBrowser() {
      if (this.isLineBrowser()) {
        const url = window.location.href;
        if (!url.includes('openExternalBrowser=1')) {
          const separator = url.includes('?') ? '&' : '?';
          window.location.href = url + separator + 'openExternalBrowser=1';
        }
      }
    }
  },
  mounted(){
    this.$store.state.actionResult = this.$refs.actionResultView
  },
  async created(){
    this.autoOpenExternalBrowser();
    // const userData = this.$api.users.getUserData()
    // if (!userData){
    //   this.$router.push('/login')
    //   return
    // }
    // this.$router.push('/dashboard/index')
    // if ( !this.$store.state.loginStatus ){
    //   this.$router.push('/login')
    // }
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
